module.exports = __webpack_public_path__ + "static/avatar-568a49d80cb4e6c9b0cdf5e72b229f6d.jpg";